<template>
    <bill-shell :hide-check-transaction="true" title="Check Transaction" subtitle="Check your previous transaction status">
        <section class="bg-light-1">
            <div class="container py-5">
                <div class="row">
                    <div class="col-lg-4" v-for="service in flatServicesList" v-if="!service.seo">
                        <div>
                            <router-link :to="service.route"
                                         data-aos-delay="50" data-aos="fade-in"
                                         class="card card-body border-0 rounded-lg mb-4 shadow-sm hover:bg-white-100">
                                <div class="d-flex">
                                    <img v-if="service.icon || service.image" style="height: 72px; width: 72px; object-fit: contain"
                                         :src="service.icon || service.image" alt=""
                                         class="bg-light-2 rounded-lg p-2">
                                    <div class="flex-grow-1 pl-3">
                                        <h6 class="mb-1">{{ service.name }}</h6>
                                        <p v-if="service.description">{{ service.description }}</p>
                                        <p v-else-if="service.displayName">{{ service.displayName }}</p>
                                        <p v-else-if="service.provider">{{ service.provider }} {{ service.service }}</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "./bill-shell.vue";
import {appDataMixin} from "../../core/data/global";

export default {
    name: "dashboard",
    components: {BillShell},
    mixins: [appDataMixin],
    data: () => ({
        content: [
            {
                title: 'Top Up Your\nEconet and NetOne Airtime',
                subtitle: 'Top up Econet and NetOne Airtime in just a few clicks. There’s a 5% Bonus airtime for all NetOne airtime purchases. Accepted payment methods on our platform include EcoCash, MasterCard, VISA, and other international cards.'
            },
            {
                title: 'Get Up To\n20% BONUS!!!',
                subtitle: 'When you pay using MasterCard, Visa, or other international cards.'
            },
        ]
    }),
    mounted() {
        // Check in Local Storage
    },
    metaInfo() {
        return {
            title: "Check Transaction Status",
        }
    }
}
</script>
